import { Turbo } from "@hotwired/turbo-rails";
import "@lib/preline_loader";
import { runComponentPackages, runControllerPackage } from "@lib/packageRunner";
import { application } from "@controllers/application";
import ProfileController from "@controllers/common/profile/profile";
import MapsController from "@controllers/common/google/google_maps";
import FieldError from "@controllers/common/field-error/field-error";
import TeamController from "@controllers/team/team";
import CarouselController from "@controllers/preline/carousel/carousel";
import MultiCarouselController from "@controllers/preline/carousel/multi-carousel";
import DatepickerController from "@controllers/common/datepicker/datepicker";
import B2bOnboardingFormController from "@controllers/preline/b2b_onboarding/b2b_onboarding_form";
import ProgressController from "@controllers/preline/progress/progress";
import VenueController from "@controllers/dashboard/memorial_venues/venue";
import LoadingController from "@controllers/preline/loading/loading";
import AutoTabsController from "@controllers/preline/auto_tabs/auto_tabs";
import CardController from "@controllers/preline/card/card";
import ReviewsIoWidgetController from "@controllers/preline/reviews_io_widget/reviews_io_widget";
import PricingTableController from "@controllers/preline/pricing_table/pricing_table";
import SliderController from "@controllers/common/slider/slider";
import ModalController from "@controllers/preline/modal/modal";
import ContentSwitch from "@controllers/preline/content_switch/content_switch";
import DropdownController from "@controllers/common/dropdown/dropdown";
import CustomerLoveController from "@controllers/website/customer_love/index";

application.register("team", TeamController);
application.register("google_maps", MapsController);
application.register("profile", ProfileController);
application.register("field-error", FieldError);
application.register("carousel", CarouselController);
application.register("multi-carousel", MultiCarouselController);
application.register("datepicker", DatepickerController);
application.register("b2b-onboarding-form", B2bOnboardingFormController);
application.register("loading", LoadingController);
application.register("progress", ProgressController);
application.register("venue", VenueController);
application.register("auto-tabs", AutoTabsController);
application.register("card", CardController);
application.register("reviews-io-widget", ReviewsIoWidgetController);
application.register("pricing_table", PricingTableController);
application.register("slider", SliderController);
application.register("modal", ModalController);
application.register("content_switch", ContentSwitch);
application.register("dropdown", DropdownController);
application.register("website--customer-love--index", CustomerLoveController);

Turbo.session.drive = false;
document.addEventListener("DOMContentLoaded", async () => {
  runControllerPackage();
  runComponentPackages();
});

document.documentElement.addEventListener("turbo:frame-load", () => {
  window.HSStaticMethods.autoInit();
  runControllerPackage();
  runComponentPackages();
});

// Ensure that autoInit is called after Turbo streams render
document.documentElement.addEventListener("turbo:before-stream-render", (event) => {
  const render = event.detail.render;

  event.detail.render = function (streamElement) {
    render(streamElement);
    window.HSStaticMethods.autoInit();

    const resizeEvent = new Event("resize");
    window.dispatchEvent(resizeEvent);

    const customEvent = new CustomEvent("turbo:after-stream-render", { detail: streamElement });
    document.dispatchEvent(customEvent);
  };
});